export function worksheetProblems(mathType, qtyProblems, lower, upper) {
  let problems = [];
  for (var i = 0; i < 10000; i++) {
    let newProblem = MathPuzzle[mathType](lower, upper);
    if (!found(newProblem, problems)) {
      problems.push(newProblem);
    }
    if (problems.length >= qtyProblems) {
      return problems;
    }
  }
}

function found(needle, haystack) {
  return (haystack.filter((straw) => {
    if (typeof straw == 'undefined') return false;
    return needle[0] === straw[0];  // answers are on 0;
  }).length > 0);
}


const MathPuzzle = {
  addition: function(lower, upper) {
    const a = rollDice(upper)+lower;
    const b = rollDice(upper)+lower;
    return [
      a + b,
      a,
      b
    ];
  },

  subtraction: function(lower, upper) {
    const b = rollDice(upper)+lower;
    const c = rollDice(upper)+lower;
    const a = b + c;
    return [
      c,
      a,
      b
    ];
  },

  multiplication: function(lower, upper) {
    const a = rollDice(upper)+lower;
    const b = rollDice(upper)+lower;
    return [
      a * b,
      a,
      b
    ];
  },

  division: function(lower, upper) {
    const b = rollDice(upper)+lower;
    const c = rollDice(upper)+lower;
    const a = c * b;
    return [
      c,
      a,
      b
    ];
  }
};

export function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex ;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export function rollDice(sides) {
  return Math.floor(Math.random() * sides);
}

export function limitsFromPlaces(number) {
  switch (parseInt(number)) {
    case 1:
      return [1, 19];
    case 2:
      return [10, 89];
    case 3:
      return [100, 899];
  }
}

export function typeFromURL() {
  const path = location.pathname;
  switch (true) {
    case /division/.test(path):
      return 'division';
    case /subtraction/.test(path):
      return 'subtraction';
    case /multiplication/.test(path):
      return 'multiplication';
    default:
      return 'addition';
  }
}

export function signFromType(type) {
  switch (type) {
    case 'division':
      return '÷';
    case 'subtraction':
      return '-';
    case 'multiplication':
      return '×';
    default:
      return '+';
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/worksheets/lib/math.js
 **/